<template>
  <profiles-header
    :id="currentTeacherGetter.teacher_gui_number"
    :name="currentTeacherGetter.teacher_name"
    login-type="teacher"
  >
    <div class="gear first mobile_hide" />
    <div class="gear second" />
    <div class="gear third" />
    <div class="gear fourth mobile_hide" />
  </profiles-header>
</template>
<script>
import { mapGetters } from 'vuex'
import ProfilesHeader from '~components/pages/ProfilesHeader'
export default {
  name: 'TeachersHeader',
  components: {
    ProfilesHeader
  },
  computed: {
    ...mapGetters('pages/teachers', [
      'currentTeacherGetter'
    ]),
  }
}
</script>
